import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
const $AUTH_URL = 'https://tearcell.com/api/dj-rest-auth/'

function initialState() {
    return {
        status: '',
        token: localStorage.getItem('token') || '',
        user: {},
        currentAppName: '',
        currentAppId: -1,
        currentGroupId: -1,
        currentCategory: {},
        currentCategoryCount: -1,
        currentResourceCount: -1,
        currentDatapointCount: -1,
        currentResource: {},
        currentDatapoint: {},
    }
}

export default new Vuex.Store({

    state: initialState,

    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, token, user) {
            state.status = 'success';
            state.token = token;
            state.user = user;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
        resource_change(state, resource) {
            state.currentResource = resource;
            state.currentResourceCount = resource.resourceCount;
        },
        category_change(state, category) {
            state.currentCategory = category;
            state.currentCategoryCount = category.categoryCount;
        },
        datapoint_change(state, datapoint) {
            state.currentDatapoint = datapoint;
            state.currentDatapointCount = datapoint.datapointCount;
        },
        set_constants(state, app) {
            state.currentAppName = app.name;
            state.currentAppId = app.pk
            state.currentGroupId = app.owning_group;
        },
        reset_store(state) {
            const s = initialState();

            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },

    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request');
                axios({ url: `${$AUTH_URL}login/`, data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.key;
                        const user = 'placeholder';
                        localStorage.setItem('token', token);
                        axios.defaults.headers.common['Authorization'] = 'Token ' + token;
                        commit('auth_success', token, user);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('auth_error');
                        localStorage.removeItem('token');
                        reject(err);
                    });
            });
        },

        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                localStorage.removeItem('token');
                delete axios.defaults.headers.common['Authorization']
                commit('reset_store');
                resolve();
            })
        },

        resource_change({ commit }, resource) {
            commit('resource_change', resource);
        },

        category_change({ commit }, category) {
            commit('category_change', category);
        },

        datapoint_change({ commit }, datapoint) {
            commit('datapoint_change', datapoint);
        },

        set_constants({ commit }, app) {
            commit('set_constants', app);
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        curGroup: state => state.currentGroupId,
        curResource: state => state.currentResourceCount,
        curCategory: state => state.currentCategory,
        appName: state => state.currentAppName,
        appId: state => state.currentAppId,
    }
})